module.exports = __webpack_public_path__ + "static/privat24-4a2822416b3d511ef9c129a8bc7c3830.png";